

export class DialogConfig {

  public static readonly minWidth: '250px';
}
